import { render, staticRenderFns } from "./PriceMain.vue?vue&type=template&id=01c96d0a&"
import script from "./PriceMain.vue?vue&type=script&lang=js&"
export * from "./PriceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports